import styled from 'styled-components';

export const ErrorMessage = styled.div`
    color: red;
    font-weight: 700;
    padding: 20px 0;
`;
